import { render, staticRenderFns } from "./CommissionsPayable.vue?vue&type=template&id=00c1e884"
import script from "./CommissionsPayable.vue?vue&type=script&lang=js"
export * from "./CommissionsPayable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports